import apiClient from '../client';
import $U from '../urls';

export const fetchFavourites = (limit = 12, page = 1) => {
  const params = { limit, page };

  return apiClient.request('GET', $U.FAVOURITE, params);
};

export const addFavourite = productPk => {
  const data = {
    product: productPk,
  };

  return apiClient.request('POST', $U.FAVOURITE, data);
};

export const removeFavourite = favouritePk => {
  return apiClient.request('DELETE', `${$U.FAVOURITE}${favouritePk}/`);
};

export const fetchFavouriteStatus = productIds => {
  const limit = productIds.length;
  const query = productIds
    .map(productId => `product_id=${productId}`)
    .join('&');

  return apiClient.request('GET', `${$U.FAVOURITE}?limit=${limit}&${query}`);
};
